import { isElement, isNaN, forEach, debounce } from 'lodash';

/******************************************
 * SORT MODULE
 * 
 * This module is used for sorting a list 
 * based on a preset of parameters
 *  
 ******************************************/
const
	moduleName = 'sort',
	selectors = {
		base: `.js-${moduleName}`,
		trigger: `.js-${moduleName}-trigger`,
		target: `.js-${moduleName}-target`
	};

export default class Sort {

	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error(`element has not been found.`);
			return false;
		}

		this.baseElement = baseElement;
		this.triggers = this.baseElement.querySelectorAll(selectors.trigger);
		this.target = this.baseElement.querySelector(selectors.target);

		this._bindEvents();

	}


	_bindEvents() {
		forEach(this.triggers, trigger => {
			trigger.addEventListener('click', debounce(this._onClickHandler.bind(this), 300, { 'leading': true, 'trailing': false }));
		});
	}


	_onClickHandler(ev) {
		ev.stopPropagation()
		const input = ev.currentTarget,
			// get data-attribute to define sorting paramter
			dataSort = input.dataset ?.sort,
			resultList = this.baseElement.querySelector(selectors.target),
			// get all the result lists			
			sortingLists = resultList.querySelectorAll('ul');
				
		forEach(sortingLists, list => {
			const sortData = `sort-${dataSort}`,
				children = list.children;

			Array.from(children)
				.sort((a, b) => {
					const
						aNumber = a.dataset[`sort${dataSort}`].replace(/[^\d,]/g, ''),
						bNumber = b.dataset[`sort${dataSort}`].replace(/[^\d,]/g, ''),
						aSort = parseInt(aNumber),
						bSort = parseInt(bNumber);
					let result = 0;
					
					if (!isNaN(aSort) && isNaN(bSort)) {
						result = -1;
					}
					if (isNaN(aSort) || aSort > bSort ) {
						result = 1;
					}
					if (isNaN(bSort) || bSort > aSort) {
						result = -1;
					}

					return result;
				}) // To reverse it, use `b.localeCompare(a)`.
				.forEach((item) => {
					item.parentNode.appendChild(item);
				});
		});
	}
}

const initSort = () => {
	forEach(document.querySelectorAll(selectors.base), element => {
		const sort = new Sort(element);
	});
}

initSort();